/* eslint-disable no-restricted-syntax */
/* eslint-disable no-return-await */
import React, { useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2';
import { MapContainer, GeoJSON } from 'react-leaflet';
import { Form } from '@unform/web';
import { FaEllipsisH, FaInfo } from 'react-icons/fa';
import {
  Card,
  Col,
  Row,
  Table,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from 'reactstrap';
import { toast } from 'react-toastify';
import geoViewport from '@mapbox/geo-viewport';
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import { Select } from '../../components/unform/index';
import api from '../../services/api';
import 'leaflet/dist/leaflet.css';
import { Translator } from '../../components/i18n';

function Talhoes({ idFazenda }) {
  const erroBuscaDados = Translator({
    path: 'erroBuscaDados',
  });
  const dadosSalvosSucesso = Translator({
    path: 'dadosSalvosSucesso',
  });
  const erroSalvarDados = Translator({
    path: 'erroSalvarDados',
  });
  const ativo = Translator({
    path: 'fazenda.ativetalhoes.ativo',
  });
  const inativo = Translator({
    path: 'fazenda.ativetalhoes.inativo',
  });
  const geoJSONref = useRef(null);

  const [talhoes, setTalhoes] = useState([]);
  const [selectedTalhao, setSelectedTalhao] = useState(null);
  const [defaultGeoJSON, setDefaultGeoJSON] = useState(null);

  const [randomKey, setRandomKey] = useState(1);
  const [map, setMap] = useState();

  const [filtro, setFiltro] = useState({});

  const [modalInfo, setModalInfo] = useState(false);

  const toggleInfo = () => setModalInfo(!modalInfo);

  async function getTalhoes() {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const params = Object.keys(filtro)
      .map((e) => {
        if (e === 'page') {
          if (Number.isNaN(filtro[e])) {
            return `${e}=${1}`;
          }
        }
        return `${e}=${filtro[e]}`;
      })
      .join('&');

    const { data } = await api.get(`/talhoes-fazenda/${idFazenda}?${params}`);

    setTalhoes(data);
    window.scrollTo(0, 0);

    Swal.close();
  }

  useEffect(() => {
    getTalhoes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtro]);

  const infosTalhao = async (id) => {
    toggleInfo();
    setRandomKey(Math.random());
    setDefaultGeoJSON(null);
    setSelectedTalhao(null);
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const { data } = await api.get(`/talhao/${id}`);

      setSelectedTalhao(data);

      setTimeout(() => {
        setDefaultGeoJSON(data?.talhao?.objeto);
      }, 2500);

      Swal.close();
    } catch (err) {
      toast.error(erroBuscaDados);
      Swal.close();
    }
  };

  useEffect(() => {
    function updateMap() {
      if (map && selectedTalhao) {
        setTimeout(() => {
          const objZoomViewport = geoViewport.viewport(selectedTalhao?.bounds, [
            window.innerWidth,
            window.innerHeight,
          ]);

          map.flyTo(
            [
              selectedTalhao?.coordenadas?.lati,
              selectedTalhao?.coordenadas?.long,
            ],
            objZoomViewport?.zoom - 2,
            {
              animate: true,
              duration: 2,
            }
          );
        }, 500);
      }
    }
    updateMap();
  }, [map, selectedTalhao]);

  async function statusTalhaoSafra(idTalhao, status) {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const body = {
        id_talhao: idTalhao,
        id_fazenda: idFazenda,
        status,
      };

      await api.put('/ativa-safra-talhao', body);
      toast.success(dadosSalvosSucesso);
      Swal.close();
    } catch (err) {
      toast.error(erroSalvarDados);
      Swal.close();
    }
  }

  async function ativarTodos() {
    Swal.fire({
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    for await (const [, talhao] of Object.entries(talhoes)) {
      try {
        const body = {
          id_talhao: talhao?.id,
          id_fazenda: idFazenda,
          status: 'A',
        };

        await api.put('/ativa-safra-talhao', body);
        toast.success(dadosSalvosSucesso);

        setTalhoes();
      } catch (err) {
        toast.error(erroSalvarDados);
        Swal.close();
      }
    }
    const newArray = [];
    talhoes.forEach((e) => {
      e.status = 'A';
      newArray.push(e);
    });

    setTalhoes(newArray);
    Swal.close();
  }

  return (
    <>
      <Card style={{ maxHeight: 500, overflowY: 'auto' }}>
        {talhoes?.length && (
          <Button className="mt-2 mb-2" onClick={() => ativarTodos()}>
            Ativar todos os talhões
          </Button>
        )}
        <Form>
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translator path="fazenda.safratalhoescroqui.talhoes.descricao" />
                </th>
                <th>
                  <Translator path="fazenda.safratalhoescroqui.talhoes.tamanho" />
                </th>
                <th>
                  <Translator path="fazenda.safratalhoescroqui.talhoes.status" />
                </th>
                <th className="text-center">
                  <Translator path="fazenda.safratalhoescroqui.talhoes.acao" />
                </th>
              </tr>
            </thead>
            <tbody>
              {talhoes?.length ? (
                talhoes?.map((c) => (
                  <tr key={c?.value}>
                    <td>{c?.descricao}</td>
                    <td>{c?.tamanho && Number(c?.tamanho)} h</td>
                    <td className="text-center">
                      <Select
                        label=""
                        className="form-control"
                        name="tipo_documento"
                        defaultValue={c?.status}
                        onChange={(e) => {
                          statusTalhaoSafra(c?.id, e?.target?.value);
                        }}
                        data={[
                          {
                            id: 'I',
                            label: inativo,
                            value: 'I',
                          },
                          {
                            id: 'A',
                            label: ativo,
                            value: 'A',
                          },
                        ]}
                      />
                    </td>
                    <td className="text-center">
                      <UncontrolledDropdown size="xs">
                        <DropdownToggle color="link link-gray" size="xs">
                          <FaEllipsisH size="1.3em" color="#43b02a" />
                        </DropdownToggle>
                        <DropdownMenu right>
                          <DropdownItem
                            onClick={() => {
                              infosTalhao(c?.value || c?.id);
                            }}
                            size="xs"
                          >
                            <FaInfo className="mr-1" size={18} />
                            <Translator path="fazenda.safratalhoescroqui.safras.acao.verinfotalhoes" />
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td>
                    <Translator path="excecoes.semregistros" />
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Form>
      </Card>

      <Modal
        isOpen={modalInfo}
        toggle={toggleInfo}
        allowOutsideClick={false}
        size="lg"
      >
        <ModalHeader
          toggle={() => {
            toggleInfo();
          }}
        >
          <Translator path="mapa.info.label" />
        </ModalHeader>
        <ModalBody>
          <Row style={{ textAlign: 'center' }}>
            <Col>
              <h4>
                <Translator path="gestaocoleta.talhao" />:{' '}
                {selectedTalhao?.talhao?.descricao}
              </h4>
            </Col>
            <Col>
              <h4>
                <Translator path="fazenda.safratalhoescroqui.talhoes.tamanho" />
                :{' '}
                {selectedTalhao?.talhao?.tamanho &&
                  Number(selectedTalhao?.talhao?.tamanho)}{' '}
                h
              </h4>
            </Col>
          </Row>
          <hr />
          <MapContainer
            center={[-16.804541, -56.425781]}
            whenCreated={setMap}
            zoom={3}
            scrollWheelZoom={false}
          >
            <ReactLeafletGoogleLayer
              apiKey="AIzaSyBCdSTyT5w8MEFXVyqz19IV3AMD9D3fUGw"
              type="hybrid"
              useGoogMapsLoader
            />

            {defaultGeoJSON &&
              defaultGeoJSON?.map((e) => (
                <>
                  <GeoJSON
                    key={e?.fileName + randomKey}
                    ref={geoJSONref}
                    data={e?.features}
                    style={{
                      fill: true,
                      stroke: true,
                      color: '#FFFF00',
                      fillColor: '#FFFF004D',
                      opacity: 0.8,
                      dashArray: '30 10',
                      weight: 2,
                      fillOpacity: 0.8,
                      strokeWidth: 2,
                    }}
                  />
                </>
              ))}
          </MapContainer>
        </ModalBody>
      </Modal>
    </>
  );
}

export default Talhoes;
